<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="About Institute" :links="[{title:'Home', url:'/'},{title:'About Institute'}]"></page-header>
      <section class="pt-10 pb-20 px-2 sm:px-0 bg-gray-200">
        <div class="container-2">
            <div class="sidebar">
              <page-side-bar-menu :menus="[{title:'Menu1',active:true, 'url':'/'}]"></page-side-bar-menu>
            </div>
            <div class="content">
              <div class="heading-black1">Heading</div>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium atque cum doloremque numquam porro, provident quaerat quis repellat sequi similique, sunt vel voluptates. Commodi ex nisi nulla, quia quidem quisquam.
            </div>

        </div>
      </section>
      <section class="pt-20 pb-32 relative block bg-blue">
        <div class="container mx-auto px-4">
          <div class="flex flex-wrap justify-center text-center mb-10">
            <div class="w-full lg:w-6/12 px-4">
              <h2 class="text-4xl font-semibold text-white">Programmes Run by the Institute</h2>
            </div>
          </div>
          <div class="flex justify-center">
            <table class="rounded-md shadow-lg">
              <thead class="bg-gray-200">
              <tr>
                <th scope="col">
                  #
                </th>
                <th scope="col">
                  Name of Programme
                </th>
                <th>Intake</th>
              </tr>
              </thead>
              <tbody>
              <tr class="bg-white border-b">
                <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">1
                </td>
                <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">
                  Computer Engineering
                </td>
                <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">60
                </td>

              </tr>
              <tr class="bg-white border-b">
                <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">2</td>
                <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">
                  Computer Engineering
                </td>
                <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">60
                </td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "../components/Navbar.vue";
import FooterComponent from "../components/Footer.vue";
import PageHeader from "../components/PageHeader";
import PageSideBarMenu from "../components/PageSideBarMenu";
export default {
  name: "landing-page",
  components: {
    NavbarComponent,
    PageHeader,
    PageSideBarMenu,
    FooterComponent,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped>
</style>
